import Image from "next/image";

import Typography from "@mui/material/Typography";

import { StrapiComponentType, DeepSkyType, StrapiCollectionType } from "@/src/type";
import { StringHelper } from "@/src/util";

import styles from "./Facts.module.scss";

import FactsSinglePricing from "./FactsSinglePricing";
import FactsSplitPricing from "./FactsSplitPricing";

interface FactsProps {
  propertyUnitDetails: StrapiComponentType.Section.PropertyUnitDetails;
  floorplan: DeepSkyType.AssetType.PropertyInventory.MarketingFloorPlan;
  propertyFloorplan?: StrapiCollectionType.PropertyFloorplan;
}

function Facts({ propertyUnitDetails, floorplan, propertyFloorplan }: FactsProps) {
  const area = propertyFloorplan?.area ?? floorplan.minFloorArea.value;
  const baths = propertyFloorplan?.bathrooms ?? floorplan.numberOfBathrooms;
  const beds = propertyFloorplan?.bedrooms ?? floorplan.numberOfBedrooms;

  function getBedrooms() {
    if (beds === 0) {
      return propertyUnitDetails.studioTitle;
    }
    return `${beds} ${propertyUnitDetails.bedsTitle}`;
  }

  function getAreaUnit() {
    const isSqMeters = !propertyFloorplan?.areaUnit ? floorplan.minFloorArea.units === "SQ_ME" : propertyFloorplan?.areaUnit === "sqm";
    if (isSqMeters) {
      return "m²";
    }
    return "sqft";
  }

  return (
    <div className={styles.container}>
      {propertyFloorplan?.startingAtFurnishedPrice && (
        <FactsSplitPricing
          propertyUnitDetails={propertyUnitDetails}
          floorplan={floorplan}
        />
      )}
      {!propertyFloorplan?.startingAtFurnishedPrice && (
        <FactsSinglePricing
          propertyUnitDetails={propertyUnitDetails}
          floorplan={floorplan}
        />
      )}
      <div className={styles.facts}>
        <div className={styles.item}>
          <Image
            src="/image/icon_bed.svg"
            alt="Beds Icon"
            width={24}
            height={24}
          />
          <Typography variant="body1">{getBedrooms()}</Typography>
        </div>
        <div className={styles.item}>
          <Image
            src="/image/icon_bath.svg"
            alt="Baths Icon"
            width={24}
            height={24}
          />
          <Typography variant="body1">
            {baths} {propertyUnitDetails.bathsTitle}
          </Typography>
        </div>
        <div className={styles.item}>
          <Image
            src="/image/icon_measurement.svg"
            alt="Measurement Icon"
            width={24}
            height={24}
          />
          <Typography variant="body1">
            {StringHelper.addCommasToNumber(`${area}`)} {getAreaUnit()}
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default Facts;
